module.exports = __webpack_public_path__ + "images/dataquest-vs-365datascience-courses.jpg";